import { render } from "./ChangePasscode.vue?vue&type=template&id=0db317d2"
import script from "./ChangePasscode.vue?vue&type=script&lang=js"
export * from "./ChangePasscode.vue?vue&type=script&lang=js"

import "./ChangePasscode.vue?vue&type=style&index=0&id=0db317d2&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__